import React from 'react'
import { Trans } from '@mc/i18n'
import { BOGO_I18N_NAMESPACE } from '../../../i18n'

interface ContentItemProps {
  titleKey: string
  descriptionText: string
}

export const ContentItem = ({
  titleKey,
  descriptionText,
}: ContentItemProps) => (
  <div className='mc-mb-8'>
    <h2 className='mc-text--brand mc-mb-4 mc-text-d1 mc-text--uppercase'>
      <Trans i18nKey={titleKey} ns={BOGO_I18N_NAMESPACE}>
        <span className='mc-text-color--primary' />
      </Trans>
    </h2>
    <p>{descriptionText}</p>
  </div>
)
